import directus from "api/services/directus";
import { PromotedStrain } from "custom-types/Directus";
import logError from "utils/logError";

const getPromotedStrains = async () => {
  try {
    const { data } = await directus.get<PromotedStrain[]>("promoted_strains");

    // the data should return sorted, but just in case...
    return data.sort((a, b) => (a.sort || 0) - (b.sort || 0));
  } catch (e) {
    logError(e.message, {
      functionName: "getPromotedStrains",
      service: "directus",
      statusCode: e.statusCode,
    });

    return [];
  }
};

export default getPromotedStrains;
